import type { NotifsTrackerUser } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getNotifsSent = async (roomId: string, notificationId: string) => {
  const url = `/eventReview/v1/notifications/${roomId}/${notificationId}`;
  const res = await Api.get<NotifsTrackerUser[]>(url);
  return res && res.data;
};
